// extracted by mini-css-extract-plugin
export default {"subTitle":"ReturnResultPayments_subTitle__vSgiG","divider":"ReturnResultPayments_divider__XJiwx","bigDivider":"ReturnResultPayments_bigDivider__+T492"};